"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("@material-ui/core/styles");
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: function root(_ref) {
      var gridColor = _ref.gridColor;
      return {
        height: 'auto',
        borderRadius: '10px',
        fontSize: '13px',
        background: '#F7F7F7',
        textTransform: 'none',
        padding: '8px',
        paddingRight: '16px',
        overflow: 'clip',
        minHeight: '47px',
        '& .loader': {
          left: '50%',
          transform: 'translate(-50%, -50%)',
          top: '50%',
          position: 'absolute'
        },
        '&:hover': {
          background: gridColor + '33',
          '& div': {
            color: gridColor + ' !important'
          }
        }
      };
    },
    grid: function grid(_ref2) {
      var gridColor = _ref2.gridColor;
      return {
        width: '31px',
        height: '31px',
        minWidth: '31px',
        borderRadius: '8px',
        backgroundColor: gridColor || '#eee'
      };
    },
    title: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: 'auto',
      marginBottom: 'auto',
      color: '#212529',
      fontSize: '13px',
      lineHeight: '13px'
    },
    titleRight: {
      fontWeight: 300
    },
    subtitle: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: 'auto',
      marginBottom: 'auto',
      fontSize: '10px',
      lineHeight: '10px',
      color: '#494949'
    },
    subtitleRight: {
      fontWeight: 300
    }
  };
}, {
  name: 'BannerButton'
});
exports.useStyles = useStyles;